import DataLoader from "dataloader"
import { useQuery } from "@tanstack/react-query"
import { personGetSimplePersonsByIds } from "@/orval/gen"

const loader = new DataLoader(
  async (keys: readonly number[]) => {
    const results = await personGetSimplePersonsByIds({
      ids: [...keys],
    })
    return keys.map((key) => results?.find((x) => x.personId === key))
  },
  { batchScheduleFn: (callback) => setTimeout(callback, 100) }
)

export function useBatchedSimplePerson(key?: number) {
  return useQuery({
    queryKey: ["SimplePerson", key],
    queryFn: () => loader.load(key!),
    enabled: key !== undefined,
  })
}
